import { Link } from "react-router-dom";

function Campaigns() {
  return (
    <div className="space-y-6">

      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">
            Campaigns
          </h1>
          <p className="text-sm text-gray-500">
            Manage your marketing campaigns
          </p>
        </div>

        <Link
          to="/campaigns/new"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          + Add Campaign
        </Link>
      </div>

      {/* Campaign Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-600">
            <tr>
              <th className="p-4">Name</th>
              <th>Status</th>
              <th>Leads</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="divide-y">
            <tr className="hover:bg-gray-50">
              <td className="p-4 font-medium">
                Facebook Ads 2026
              </td>
              <td>
                <span className="bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs">
                  Active
                </span>
              </td>
              <td>120</td>
              <td>
                <Link
                  to="/campaigns/1"
                  className="text-blue-600 hover:underline text-sm"
                >
                  Manage
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Campaigns;
